import type { WEI, } from "@bracket/blocksmith";


/**
 * Interface for WEI asset configuration
 * Provides decimal precision information for the asset
 */
export interface IWEIAsset {
	chainId?: number;
	symbol?: string;
	label?: string;
	/** default fixed precision for this asset */
	precision?: number;
	/**
	 * Number of decimal places for this asset
	 * @example
	 * { decimals: 18 } // Ethereum standard
	 * { decimals: 6 }  // USDC
	 * { decimals: 8 }  // Bitcoin
	 */
	decimals: number;
}

/**
 * Type guard to check if a value is a valid IWEIAsset
 *
 * @param {unknown} value - The value to check
 * @returns {boolean} True if the value is a valid IWEIAsset
 */
export const isIWEIAsset = (value: unknown): value is IWEIAsset => {
	return typeof value === "object" && value !== null && "decimals" in value && typeof (value as IWEIAsset).decimals === "number" && Number.isInteger((value as IWEIAsset).decimals) && (value as IWEIAsset).decimals >= 0;
};
